import { ViewModelForm } from "@xengage/gw-portals-viewmodel-react";
import React, { useCallback, useContext, useState} from "react";
import cx from 'classnames'
import _ from 'lodash'
import LocationAddress from "ent-capability-quoteandbind-common-react/components/LocationAddress/LocationAddress.jsx";
import { Flex } from '@jutro/layout'
import { Chevron, Icon } from '@jutro/components';
import { TranslatorContext } from "@jutro/locale";
import metadata from './TWIABuildingLocationAccordion.metadata.json5'
import styles from '../TWIABuildingSummaryAccordions.module.scss';
import { BldgLocContext } from '../../../context/BuildingsAndLocationContext';
import messages from './TWIABuildingLocationAccordion.messages.js';

function TWIABuildingLocationAccordion(props) {
    const { handleEditLinkClick, wizardStep, isConfirmationStep } = props;
    const translator = useContext(TranslatorContext)
    const { chosenLocation, chosenBuildingIndex } = useContext(BldgLocContext);
    const [selectedLocation] = chosenLocation;
    const [selectedBuildingIndex, setSelectedBuildingIndex] = chosenBuildingIndex;
    const [building, setBuildingVM] = useState(selectedLocation.buildings.children[selectedBuildingIndex]);
    const locationHeader = useCallback((isOpen) => (
            <Flex className={styles.fullWidth}>
                <Icon
                    icon="gw-location"
                    id="locCheck"
                    size="medium"
                />
                <div className={cx(styles.heading, styles.headingBold, styles.flexOneThird)}>{translator(messages.locationHeading)}</div>
                <div className={cx(styles.heading, styles.flexOneThird)}>{_.get(selectedLocation, 'displayName.value')}</div>
                <Chevron className={styles.chevronMargin} isOpen={isOpen} />
            </Flex>
        ), [selectedLocation, translator])

    const editLocation = useCallback(() => {
        if(wizardStep === -1 || isConfirmationStep) {
        handleEditLinkClick(0,false,true, undefined, building)
        } else {
        handleEditLinkClick(0, undefined, undefined, undefined, building)
        }
    }, [handleEditLinkClick])

    const resolvers = {
        resolveCallbackMap: {
            locationHeader,
            editLocation
        },
        resolveClassNameMap: styles,
        resolveComponentMap: {
            locationAddressComponent: LocationAddress
        }
    }

    const overrideProps = {
        locationAddress: {
            location: selectedLocation.value
        }
    }

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={selectedLocation}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
        />
    )
}

export default TWIABuildingLocationAccordion
